export enum ActionType {
  /**************/
  /*            */
  /* SET LOCALE */
  /*            */
  /**************/
  SET_LOCALE = 'set_locale'
}
